<template>
  <div class="createOrg-component">
    <div class="createOrg-container">
      <div class="global_popup_header">
        {{ title }}
        <i @click="$store.commit('windowHandle')"></i>
      </div>
      <div class="createOrg_form" v-bar>
        <div class="createOrg_form_main">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="formData"
            @submit.native.prevent
            label-position="top"
          >
            <el-form-item
              v-for="item in ruleProps"
              :key="item.prop"
              :label="item.label"
              :prop="item.isMandatory ? item.prop : null"
              @keyup.enter.native="submitForm('formData')"
            >
              <el-select
                class="createOrg-tag"
                v-if="item.prop === 'tagId'"
                v-model="ruleForm[item.prop]"
                :placeholder="item.placeholder"
              >
                <el-option
                  v-for="item in tags"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select
                class="createOrg-tag"
                v-else-if="item.prop === 'country'"
                v-model="ruleForm[item.prop]"
                :placeholder="item.placeholder"
              >
                <el-option
                  v-for="item in country"
                  :key="item.short"
                  :label="$store.state.language === 'zh' ? item.name : item.en"
                  :value="item.short"
                >
                </el-option>
              </el-select>
              <el-select
                class="createOrg-tag"
                v-else-if="item.prop === 'lang'"
                v-model="ruleForm[item.prop]"
                :placeholder="item.placeholder"
              >
                <el-option
                  v-for="item in language"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <area-select
                v-else-if="item.prop === 'areaArr'"
                size="small"
                type="code"
                :level="2"
                v-model="ruleForm[item.prop]"
                icon="direction-right-icon"
                :data="pcaa"
              />
              <el-input
                v-else
                v-model="ruleForm[item.prop]"
                :placeholder="item.placeholder"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="global_popup_footer">
        <button @click="submitForm('formData')">
          {{ $t("commonMsg.confirm") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { pcaa } from "area-data";
import { language, country } from "@/utils/country";
export default {
  props: {
    title: String,
    orgItem: Object
  },
  computed: {
    rules() {
      let verifyFid = (rule, value, callback) => {
        if (!value) return callback(new Error(this.$t("verify.orgId")));
        else if (!/^[0-9]*$/.test(value))
          return callback(new Error(this.$t("verify.num")));
        if (Object.keys(this.orgItem).length) {
          callback();
          return;
        }
        this.$http
          .verifyFid({ fid: value })
          .then(res => {
            res.data
              ? callback(new Error(this.$t("verify.orgExist")))
              : callback();
          })
          .catch(() => {
            callback(new Error("请求失败"));
          });
      };
      let rules = {
        name: [
          {
            required: true,
            message: this.$t("verify.orgName"),
            trigger: "blur"
          }
        ],
        areaArr: [
          {
            required: true,
            message: this.$t("verify.orgArea"),
            trigger: "blur"
          }
        ],
        tag: [
          { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        ],
        fid: [{ required: true, validator: verifyFid, trigger: "blur" }],
        address: [
          {
            required: true,
            message: this.$t("verify.orgAddress"),
            trigger: "blur"
          }
        ],
        country: [
          {
            required: true,
            message: this.$t("placeholder.select"),
            trigger: "blur"
          }
        ],
        lang: [
          {
            required: true,
            message: this.$t("placeholder.select"),
            trigger: "blur"
          }
        ]
      };
      return rules;
    },
    ruleProps() {
      let ruleProps = [
        {
          prop: "name",
          label: this.$t("org.orgName"),
          placeholder: this.$t("placeholder.orgName"),
          isMandatory: true
        },
        {
          prop: "fid",
          label: "fid",
          placeholder: "fid",
          isMandatory: false
        },
        {
          prop: "tagId",
          label: this.$t("org.tag"),
          placeholder: this.$t("placeholder.select"),
          isMandatory: false
        },
        {
          prop: "country",
          label: this.$t("org.country"),
          placeholder: this.$t("placeholder.select"),
          isMandatory: true
        },
        {
          prop: "lang",
          label: this.$t("firmware.lang"),
          placeholder: this.$t("placeholder.select"),
          isMandatory: true
        },
        {
          prop: "areaArr",
          label: this.$t("org.area"),
          placeholder: this.$t("placeholder.area"),
          isMandatory: false
        },
        {
          prop: "address",
          label: this.$t("commonMsg.address"),
          placeholder: this.$t("placeholder.address"),
          isMandatory: false
        }
      ];
      return ruleProps;
    }
  },
  data() {
    return {
      language,
      country,
      pcaa: pcaa,
      tags: [],
      ruleForm: {
        name: "",
        tagId: "",
        areaArr: [],
        country: "",
        lang: "",
        address: "",
        fid: ""
      }
    };
  },

  methods: {
    getOrgList() {
      this.$http.getTagList().then(res => {
        this.tags = res.data.rows;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            form: this.ruleForm,
            type: !Object.keys(this.orgItem).length ? "create" : "edit"
          };
          this.$emit("createEvn", data);
          this.$store.commit("windowHandle");
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    document.querySelectorAll(".area-selected-trigger")[0].innerText = this.$t(
      "placeholder.select"
    );
    document.querySelectorAll(".area-selected-trigger")[1].innerText = this.$t(
      "placeholder.select"
    );
    document.querySelectorAll(".area-selected-trigger")[2].innerText = this.$t(
      "placeholder.select"
    );
    this.getOrgList();
    if (!Object.keys(this.orgItem).length) return;
    this.ruleForm = Object.assign(this.ruleForm, this.orgItem);
  }
};
</script>

<style lang="scss">
.createOrg-component {
  @include globalPopup(600px, 90%, 4px);
  .createOrg-container {
    overflow: hidden;
    flex: 1;
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    > .createOrg_form {
      flex: 1;
      padding: 0 74px;
      display: flex;
      margin-bottom: 20px;
      > .createOrg_form_main {
        flex: 1;
      }
    }
    .createOrg-tag {
      width: 100%;
    }
    .area-select:first-child {
      margin-left: 0;
    }
  }
}
</style>
